import request from "@/plugins/axios"
//上传汇总任务
let prefix = "eids-invoice/tcs/entReq";

export function pageList(criteria) {
  return request({
    url: prefix + '/pagelist',
    method: 'post',
    data: criteria,
  })
}

export function add(criteria) {
  return request({
    url: prefix + '/add',
    method: 'post',
    data: criteria,
  })
}
